<section class="container">
    <div class="content">
        <div class="content-top">
            <div class="content-block content-block-padding">
                <div class="trafik-header">
                    <div class="trafik-header-info">
                        <app-profile-icon [size]='54'></app-profile-icon>
                        <span class="trafik-header-text">
                            <span class="trafik-header-text-welcome">{{ "Dashboard.welcome" | translate }}</span>
                            <span class="trafik-header-text-email">{{user?.email}}</span>
                        </span>
                    </div>
                    <div class="trafik-header-button">
                        <app-button [text]="'Dashboard.buy' | translate" (btnClick)="goToSubscription()"></app-button>
                    </div>
                </div>
                <div class="divider"></div>
                <app-trafik-panel [remainingTraffic]="service?.overUsedInGB() + ' GB' || '0 GB'"
                    [totalTraffic]="service?.usageCapInGB() + ' GB' || '0 GB'"></app-trafik-panel>
            </div>
            <div class="content-block content-block-padding">
                <app-recharge-record [invoices]="invoices"></app-recharge-record>
            </div>
        </div>
        <div class="content-bottom">
            <div class="content-block">
                <div class="instruction">
                    <div class="instruction-menu">
                        <app-menu></app-menu>
                    </div>
                    <div class="instruction-content">
                        <div class="instruction-content-wrapper">
                            <div class="block-header">
                                <span class="header-title">{{"Dashboard.installClient" | translate}}</span>
                            </div>
                            <div class="redline"></div>
                            <app-client-installation [deliveryIps]="deliveryIps"></app-client-installation>
                        </div>
                        <div class="vertical-divider"></div>
                        <div class="instruction-content-wrapper">
                            <app-third-party-client [deliveryIps]="deliveryIps"></app-third-party-client>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>